import { useEffect } from 'react';

/**
 * Hook para detectar combinación de teclas secreta para abrir admin
 * Usa Ctrl+Shift+A (Cmd+Shift+A en Mac)
 */
export function useAdminShortcut() {
    useEffect(() => {
        const handleKeyPress = (e) => {
            // Ctrl+Shift+A o Cmd+Shift+A
            if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'A') {
                e.preventDefault();
                const adminUrl = process.env.REACT_APP_ADMIN_URL;
                if (adminUrl) {
                    window.open(adminUrl, '_blank');
                } else {
                    console.error('REACT_APP_ADMIN_URL no está configurada en .env');
                }
            }
        };

        window.addEventListener('keydown', handleKeyPress);
        return () => window.removeEventListener('keydown', handleKeyPress);
    }, []);
}
